export default "__VITE_ASSET__Byg9GEKh__"